export const SPECIFIC_HELP_KEY = {
    STID_ID_MOBILE : "STID_ID_MOBILE",
    HID_MOBILE_ACCESS : "HID_MOBILE_ACCESS",
    MQTT_ACCOUNT : "MQTT_ACCOUNT",
    ACCESS_GROUP_REPORT : "ACCESS_GROUP_REPORT",
    ABSENTEEISM_REPORT : "ABSENTEEISM_REPORT",
    TRANSACTION_REPORT : "TRANSACTION_REPORT",
    AREA_REPORT: "AREA_REPORT",
    CARD_EXPIRY_REPORT: "CARD_EXPIRY_REPORT",
    ENROLMENT_REPORT: "ENROLMENT_REPORT",
    FIRST_IN_LAST_OUT_REPORT: "FIRST_IN_LAST_OUT_REPORT",
    HARDWARE_INSTALLATION_REPORT: "HARDWARE_INSTALLATION_REPORT",
    HOLIDAY_REPORT: "HOLIDAY_REPORT",
    HOURS_WORKED_REPORT: "HOURS_WORKED_REPORT",
    GENERAL_MUSTERING_REPORT: "GENERAL_MUSTERING_REPORT",
    ZONE_OCCUPANCY_REPORT: "ZONE_OCCUPANCY_REPORT",
    STILL_ON_SITE_REPORT: "STILL_ON_SITE_REPORT",
    ALARM_TRANSACTIONS_REPORT: "ALARM_TRANSACTIONS_REPORT",
    DENIED_TRANSACTIONS_REPORT: "DENIED_TRANSACTIONS_REPORT",
    STATUS_TRANSACTIONS_REPORT: "STATUS_TRANSACTIONS_REPORT",
    TIME_AND_ATTENDANCE_REPORT: "TIME_AND_ATTENDANCE_REPORT",
    IDEMIA_PRESET: "IDEMIA_PRESET",
    CONTROL_ID_PRESET: "CONTROL_ID_PRESET",
    LOCK_PRESET: "LOCK_PRESET",
    LOCKER_PRESET: "LOCKER_PRESET",
    GUARD_ROLE: "GUARD_ROLE",
    SITE_ADMIN_ROLE: "SITE_ADMIN_ROLE",
    INSTALLER_ROLE: "INSTALLER_ROLE",
    REPORTER_ROLE: "REPORTER_ROLE",
    RECEPTION_ROLE: "RECEPTION_ROLE",
    SYSTEM_OWNER_ROLE: "SYSTEM_OWNER_ROLE",
    SOFTWARE_SECURITY_POLICY: "SOFTWARE_SECURITY_POLICY",
    CERTIFICATE_SECURITY_POLICY: "CERTIFICATE_SECURITY_POLICY",
    VINGCARD_TRANSACTION_REPORT: "VINGCARD_TRANSACTION_REPORT"
}